import React from "react";

const texts = [
  `██████╗ ██╗██╗     ███████╗██╗   ██╗`,
  `██╔══██╗██║██║     ██╔════╝╚██╗ ██╔╝`,
  `██████╔╝██║██║     █████╗   ╚████╔╝ `,
  `██╔══██╗██║██║     ██╔══╝    ╚██╔╝  ╔══╗`,
  `██║  ██║██║███████╗███████╗   ██║   ║██║`,
  `╚═╝  ╚═╝╚═╝╚══════╝╚══════╝   ╚═╝   ╚══╝`,
];

export default function Logo() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 40,
      }}
    >
      <div className="hc ah cx pad-20-0-0-0 font-size-20 av at s c wc ct cl">
        {texts.map((line, index) => (
          <div
            key={index}
            className="hc ff-monospacejetbrains-mono fc-226-226-226-255 s e wc"
          >
            <div className="s t wf hf">{line}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
